<template>
  <div class="indexEchartbox">
    <div class="indexEchart">
      <el-row :gutter="24" style="margin-left:0; margin-right:0;" v-if="countData">
        <p class="indexEchart_title">数据总览</p>
        <el-col :span="4">
          <div class="grid-content" @click="$router.push({path: '/customerStatistics'})">
            <section class="grid-right-content">
              <!-- <div class="iconbox"> -->
                <!-- <p v-if="index===0">数据总览</p> -->
                <!-- <span class="icon-common commonicon"></span> -->
                <!-- <span class="icon-business commonicon" v-if="index===1"></span>
                <span class="icon-cash commonicon" v-if="index===2"></span>
                <span class="icon-report commonicon" v-if="index===3"></span> -->
              <!-- </div> -->
              <div class=" textbox ">

                <p class="textGray">
                  会员总数
                  <el-popover ref="popover1" placement="top-start" width="200" trigger="hover">
                    1、会员总数=普通会员总数（无论是否开通钱包）+营运会员总数<br/>
                    2、同比上月指的是假设今天是6月14号，则拿6月1号~6月14号的新增会员数与5月1号~5月14号的新增会员数相比
                  </el-popover>
                  <el-button class="is-circle" icon="el-icon-question" v-popover:popover1 circle></el-button>
                </p>
                <p class="grid-right-content__count" :title="countData.member.num">{{countData.member.num}}</p>
                <!-- <p v-else-if="index===1 ||index === 2" class="grid-right-content__count">{{item.count | currency}}元</p>
                <p v-else class="grid-right-content__count">{{item.count | currency}}万元</p> -->
                <p class="textGray">
                  <span :class="countData.member.rate > 0 ? 'rangeUp' : 'rangedown'">
                    <i :class="countData.member.rate > 0 ?  'icon-greenUp' : 'icon-redDown'"></i>{{countData.member.rate}}%</span>同比上月
                </p>
              </div>
            </section>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content" @click="$router.push({path: '/businessStatistics'})">
            <section class="grid-right-content">
              <div class="iconbox">
                <!-- <p v-if="index===0">数据总览</p> -->
                <!-- <span class="icon-common commonicon"></span> -->
                <!-- <span class="icon-business commonicon"></span> -->
                <!-- <span class="icon-cash commonicon"></span>
                <span class="icon-report commonicon"></span> -->
              </div>
              <div class=" textbox ">
                <p class="textGray">本月油品收入
                  <el-popover ref="popover2" placement="top-start" width="200" trigger="hover">
                    1、本月油品收入是统计付款时间在本月内的油品收入，假设产生了退款则不计算在内<br/>
                    2、同比上月指的是假设今天是6月14号，则拿6月1号~6月14号的收入与5月1号~5月14号的收入相比
                  </el-popover>
                  <el-button class="is-circle" icon="el-icon-question" v-popover:popover2 circle></el-button>
                </p>
                <p class="grid-right-content__count" :title="countData.oilOrder.amount| currency">{{countData.oilOrder.amount| currency}}</p>
                <!-- <p v-else-if="index===1 ||index === 2" class="grid-right-content__count">{{item.count | currency}}元</p>
                <p v-else class="grid-right-content__count">{{item.count | currency}}万元</p> -->
                <p class="textGray">
                  <span :class="countData.oilOrder.rate > 0 ? 'rangeUp' : 'rangedown'">
                    <i :class="countData.oilOrder.rate > 0 ?  'icon-greenUp' : 'icon-redDown'"></i>{{countData.oilOrder.rate}}%</span>同比上月
                </p>
              </div>
            </section>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content " @click="$router.push({path: '/businessStatistics'})">
            <section class="grid-right-content">
              <div class="iconbox">
                <!-- <p v-if="index===0">数据总览</p> -->
                <!-- <span class="icon-common commonicon"></span> -->
                <!-- <span class="icon-cash commonicon"></span> -->
                <!-- <span class="icon-report commonicon"></span> -->
              </div>
              <div class=" textbox ">
                <p class="textGray">本月充值金额
                  <el-popover ref="popover3" placement="top-start" width="200" trigger="hover">
                    1、本月充值金额指的是充值时间在本月内的充值金额总额（不包含赠送金额）<br/>
                    2、同比上月指的是假设今天是6月14号，则拿6月1号~6月14号的充值金额与5月1号~5月14号的充值金额相比
                  </el-popover>
                  <el-button class="is-circle" icon="el-icon-question" v-popover:popover3 circle></el-button>
                </p>
                <p class="grid-right-content__count" :title="countData.recharge.rechargeAmount| currency">{{countData.recharge.rechargeAmount| currency}}</p>
                <!-- <p v-else-if="index===1 ||index === 2" class="grid-right-content__count">{{item.count | currency}}元</p>
                <p v-else class="grid-right-content__count">{{item.count | currency}}万元</p> -->
                <p class="textGray">
                  <span :class="countData.recharge.rate > 0 ? 'rangeUp' : 'rangedown'">
                    <i :class="countData.recharge.rate > 0 ?  'icon-greenUp' : 'icon-redDown'"></i>{{countData.recharge.rate}}%</span>同比上月
                </p>
              </div>
            </section>
          </div>
        </el-col>
        <el-col :span="4" v-if="hasAuthority('pc_company_jiahua')">
          <div class="grid-content" @click="$router.push({path: '/businessStatistics'})">
            <section class="grid-right-content">
              <div class="iconbox">
                <!-- <p v-if="index===0">数据总览</p> -->
                <!-- <span class="icon-common commonicon"></span> -->
                <!-- <span class="icon-cash commonicon"></span> -->
                <!-- <span class="icon-report commonicon"></span> -->
              </div>
              <div class=" textbox ">
                <p class="textGray">本月便利店收入
                  <el-popover ref="popover4" placement="top-start" width="200" trigger="hover">
                    1、本月便利店收入是统计付款时间在本月内的油品收入，假设产生了退款则不计算在内<br/>
                    2、同比上月指的是假设今天是6月14号，则拿6月1号~6月14号的收入与5月1号~5月14号的收入相比
                  </el-popover>
                  <el-button class="is-circle" icon="el-icon-question" v-popover:popover4 circle></el-button>
                </p>
                <p class="grid-right-content__count" :title="countData.cvsOrder.amount | currency">{{countData.cvsOrder.amount | currency}}</p>
                <p class="textGray">
                  <span :class="countData.cvsOrder.rate > 0 ? 'rangeUp' : 'rangedown'">
                    <i :class="countData.cvsOrder.rate > 0 ?  'icon-greenUp' : 'icon-redDown'"></i>{{countData.cvsOrder.rate}}%</span>同比上月
                </p>
              </div>
            </section>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content no-border" @click="$router.push({path: '/businessStatistics'})">
            <section class="grid-right-content">
              <div class="iconbox">
                <!-- <p v-if="index===0">数据总览</p> -->
                <!-- <span class="icon-common commonicon"></span> -->
                <!-- <span class="icon-cash commonicon"></span> -->
                <!-- <span class="icon-report commonicon"></span> -->
              </div>
              <div class=" textbox ">
                <p class="textGray">资金池
                  <el-popover ref="popover4" placement="top-start" width="200" trigger="hover">
                    1、资金池指的是此刻所有会员的钱包余额总额<br/>
                    2、同比上月指的是假设今天是6月14号，则拿6月6月14号的钱包余额总额与5月14号时的钱包余额总额相比
                  </el-popover>
                  <el-button class="is-circle" icon="el-icon-question" v-popover:popover4 circle></el-button>
                </p>
                <p class="grid-right-content__count" :title="countData.wallet.amount | currency">{{countData.wallet.amount | currency}}</p>
                <p class="textGray">
                  <span :class="countData.wallet.rate > 0 ? 'rangeUp' : 'rangedown'">
                    <i :class="countData.wallet.rate > 0 ?  'icon-greenUp' : 'icon-redDown'"></i>{{countData.wallet.rate}}%
                  </span>同比上月
                </p>
                <!-- <p v-else-if="index===1 ||index === 2" class="grid-right-content__count">{{item.count | currency}}元</p>
                <p v-else class="grid-right-content__count">{{item.count | currency}}万元</p> -->
                <!-- <p class="textGray">
                  <span :class="countData.recharge.rate > 0 ? 'rangeUp' : 'rangedown'">
                    <i :class="countData.recharge.rate > 0 ?  'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>{{countData.recharge.rate}}%</span>同比上月
                </p> -->
              </div>
            </section>
          </div>
        </el-col>
      </el-row>
      <!-- <div slot="header">
            <span>待办事项</span>
          </div> -->
      <el-row :gutter="16">
        <el-col :span="7">
          <el-card>
            <div class="still" v-if="backlogData">
              <p class="still_title">待办事项</p>
              <p class="agenda-item" @click="backlogData.pendingApprovalNum===0 ? '' : $router.push({path: '/enterCheck'})">
                <!-- 需要处理的就用icon-need图标，反之用icon-noneed -->
                <span class=" commonicon2 " :class="backlogData.pendingApprovalNum >0 ? 'icon-need':'icon-noneed'"></span>
                待审核营运会员
                <!-- 需要处理的就用添加red类，反之用green-->
                <span class="agenda-item__count" :class="backlogData.pendingApprovalNum>0 ? 'red':'green'">{{backlogData.pendingApprovalNum}}</span>
              </p>
              <p class="agenda-item" @click="$router.push({path: '/scanPermission'})">
                <span :class="backlogData.weixinAuth ? 'icon-noneed':'icon-need'"></span>公众号授权情况
                <span class="agenda-item__count" :class="backlogData.weixinAuth ? 'green':'red'">{{backlogData.weixinAuth ? '成功' : '未成功'}}</span>
              </p>
              <p class="agenda-item" @click="$router.push({path: '/registerGive'})">
                <span :class="backlogData.registerCouponState ===2||(backlogData.registerCouponNum <20&&backlogData.registerCouponNum !==null) ? 'icon-need':'icon-noneed'"></span>
                注册赠送优惠券
                <span class="agenda-item__count" :class="backlogData.registerCouponState !==2 && (backlogData.registerCouponNum>20||backlogData.registerCouponNum === null|| backlogData.registerCouponNum===undefined) ? 'green':'red'">
                  {{ backlogData.registerCouponState === 1 ?  (backlogData.registerCouponNum !==null?`剩余${backlogData.registerCouponNum}张`:'不限'): (backlogData.registerCouponState === 0? '关闭' :'优惠券过期' )}}
                </span>
              </p>
              <p class="agenda-item" @click="$router.push({path: '/messageRcord'})">
                <span :class="backlogData.msmNum < 50 ? 'icon-need':'icon-noneed'"></span>本月短信剩余数
                <span class="agenda-item__count" :class="backlogData.msmNum >= 50 ? 'green':'red'">{{backlogData.msmNum}}</span>
              </p>
              <p class="agenda-item" @click="$router.push({path: '/invite'})">
                <span :class="backlogData.invitationCouponState ===2 ||  (backlogData.invitationCouponNum !== null && backlogData.invitationCouponNum <20 ) ? 'icon-need':'icon-noneed'"></span>邀请拉新优惠券
                <span class="agenda-item__count" :class="(backlogData.invitationCouponNum === null || backlogData.invitationCouponNum >20 ) && backlogData.invitationCouponState !==2 ? 'green':'red'">{{backlogData.invitationCouponNum | formatInvitationCouponNum(backlogData.invitationCouponState)}}</span>
              </p>

              <p class="agenda-item" @click="$router.push({path: '/customerFeedback?state=0'})">
                <span :class="backlogData.feedbackNum>0 ? 'icon-need':'icon-noneed'"></span>
                待处理客服反馈
                <span class="agenda-item__count" :class="backlogData.feedbackNum>0 ? 'red':'green'">
                  {{backlogData.feedbackNum}}
                </span>
              </p>
            </div>
          </el-card>
        </el-col>
        <el-col :span="17">
          <el-card style="height:302px;">
            <div slot="header">
              <span>油站收入</span>
              <span class="groupEchartBtn">
                <span :class="{'groupEchartBtn-active':LineType===7}" @click="LineType = 7">最近7天</span>
                <span :class="{'groupEchartBtn-active':LineType===30}" @click="LineType = 30">最近30天</span>
              </span>
            </div>
            <!-- <p class="paycheck_title">油站收入</p> -->
            <p v-if="!incomeChartData" style="position: absolute;left:50%;transform:translate(-50%,0);text-align:center;line-height: 50px;">暂无数据</p>
            <section style="height:258px" ref="Line"></section>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="7">
          <el-card>
            <div slot="header">
              <span>油站本月销售占比</span>
            </div>
            <p v-if="gasStationChartData && !gasStationChartData.data.length" style="position: absolute;left:50%;transform:translate(-50%,0);text-align:center;line-height: 50px;">暂无数据</p>
            <section style="height:300px;" ref="Pie"></section>
          </el-card>
          <!-- <el-card>
            <div slot="header">
              <span>新用户</span>
              <span class="groupEchartBtn">
                <span :class="{'groupEchartBtn-active':LineBarType === 7}" @click="LineBarType = 7">最近7天</span>
                <span :class="{'groupEchartBtn-active':LineBarType === 30}" @click="LineBarType = 30">最近30天</span>
              </span>
            </div>
            <section style="height:400px" ref="LineBar">暂无数据</section>
          </el-card> -->
        </el-col>
        <el-col :span="17">
          <el-card>
            <div slot="header">
              <span>最近6个月优惠投入产出</span>
              <div style="position: absolute;right: 30px;top: 12px;">
                <el-radio-group v-model="radio" size="small" @change="onRadioChange">
                  <el-radio-button label="0">优惠成本占比</el-radio-button>
                  <el-radio-button label="1">优惠成本&订单收益</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <section v-if="radio==='0'" key="Bars" style="height:300px" ref="Bars"></section>
            <section v-if="radio==='1'" key="LineBar2" style="height:300px" ref="LineBar2"></section>
          </el-card>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" style="margin-bottom:1px;">
        <el-col :span="8">
          <el-card>
            <div slot="header">
              <span>用户组成</span>
            </div>
            <section style="height: 400px;" ref="PieFill"></section>
          </el-card>
        </el-col>
        <el-col :span="16">

        </el-col>
      </el-row> -->
    </div>
  </div>
</template>
<script>
import echarts from 'echarts'
import 'echarts/theme/macarons.js'
import { rap, fetch, currency } from '@/utils/common.js'
const theme1 = require('@/utils/essos.project.json').theme
let url = {
  count: '/fep/pc/dashboard/count',
  // count: '/fep/pc/business/count',
  backlog: '/fep/pc/dashboard/backlog',
  incomeChart: '/fep/pc/dashboard/incomeChart',
  gasStationChart: '/fep/pc/dashboard/gasStationChart',
  newMemberChart: '/fep/pc/dashboard/newMemberChart',
  memberFormChart: '/fep/pc/dashboard/memberFormChart',
  orderIncomeChart: '/fep/pc/dashboard/orderIncomeChart',
  orderDiscountChart: '/fep/pc/dashboard/orderDiscountChart'
}
url = rap(url)
export default {
  data () {
    return {
      countData: null,
      backlogData: null,
      radio: '0',
      echartsFillPieInit: null,
      echartsPieInit: null,
      echartsBarsInit: null,
      echartsLineBarInit: null,
      echartsLineInit: null,
      echartsLineBar2Init: null,
      LineType: 7,
      incomeChartData: null,
      gasStationChartData: null,
      LineBarType: 7,
      newMemberChart: null,
      memberFormChartData: null,
      orderDiscountChartData: null,
      orderIncomeChartData: null
    }
  },
  mounted () {
    this.fetchCount()
    this.fetchBacklog()
    this.fetchIncomeChart()
    this.fetchGasStationChart()
    // this.fetchNewMemberChart()
    // this.fetchMemberFormChart()
    this.fetchOrderDiscountChart()
    this.$nextTick(() => {
      // this.echartsLine()
      // this.echartsLineBar()
      // this.echartsBars()
      // this.echartsPie()
      // this.echartsFillPie()
      // this.echartsLineBar2()
      window.onresize = () => {
        //this.echartsFillPieInit.resize()
        this.echartsPieInit.resize()
        this.echartsBarsInit.resize()
        //this.echartsLineBarInit.resize()
        this.echartsLineInit.resize()
        this.echartsLineBar2Init.resize()
      }
    })
  },
  methods: {
    echartsLine () {
      this.echartsLineInit = echarts.init(this.$refs.Line, theme1)
      let seriesData = []
      let chartType = 'line'
      this.incomeChartData.legend.forEach(item => {
        let seriesItem = {
          name: item,
          type: chartType,
          stack: false,
          data: this.incomeChartData.series && this.incomeChartData.series[item]
        }
        seriesData.push(seriesItem)
      })
      let option = {
        // title: {
        //   text: '折线图堆叠'
        // },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let tmpStr = `${params[0].axisValueLabel}<br/>`
            params.forEach(item => {
              tmpStr += `${item.marker}  ${item.seriesName} : ${item.data} 元<br/>`
            })
            return tmpStr
          }
          //'{b}: <br/>{a0} : {c0} 元<br>{a1} : {c1} 元'
        },
        legend: {
          data: this.incomeChartData.legend
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        /* toolbox: {
          right: '4%',
          feature: {
            myTool1: {
              show: true,
              title: '本周',
              icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
              onclick: function () {
                alert('myToolHandler1')
              }
            },
            myTool2: {
              show: true,
              title: '本月',
              icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
              onclick: function () {
                alert('myToolHandler2')
              }
            },
            myTool3: {
              show: true,
              title: '本年',
              icon: 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z',
              onclick: function () {
                alert('myToolHandler3')
              }
            }
          }
        }, */
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.incomeChartData.xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: seriesData
        /* [
          {
            name: '充值金额',
            type: 'line',
            stack: false,
            data: this.incomeChartData.series && this.incomeChartData.series['充值金额']
          },
          {
            name: '消费金额',
            type: 'line',
            stack: false,
            data: this.incomeChartData.series && this.incomeChartData.series['消费金额']
          }
        ] */
      }
      this.echartsLineInit.setOption(option)
    },
    echartsLineBar () {
      this.echartsLineBarInit = echarts.init(this.$refs.LineBar, theme1)
      let seriesData = []
      this.newMemberChart.legend.forEach((item, index) => {
        let seriesItem = {
          name: item,
          type: 'bar',
          data: this.newMemberChart.series[item]
        }
        if (index === this.newMemberChart.legend.length - 1) {
          seriesItem.type = 'line'
          seriesItem.yAxisIndex = 1
        }
        seriesData.push(seriesItem)
      })
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: '{a0}: {c0}<br />{a1}: {c1}<br/>{a2}: {c2}%'
        },
        /* toolbox: {
          right: '4%',
          feature: {
            myTool1: {
              show: true,
              title: '本周',
              icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
              onclick: function () {
                alert('myToolHandler1')
              }
            }
          }
        }, */
        legend: {
          data: this.newMemberChart.legend
        },
        xAxis: [
          {
            type: 'category',
            data: this.newMemberChart.xAxis,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            min: 0,
            //interval: 50,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '',
            min: 0,
            //interval: 5,
            axisLabel: {
              formatter: '{value}%'
            }
          }
        ],
        series: seriesData /* [
          {
            name: '注册用户',
            type: 'bar',
            data: this.newMemberChart.series['注册用户']
          },
          {
            name: '消费/充值用户',
            type: 'bar',
            data: this.newMemberChart.series['消费/充值用户']
          },
          {
            name: '转化率',
            type: 'line',
            yAxisIndex: 1,
            data: this.newMemberChart.series['转华率']
          }
        ]*/
      }
      this.echartsLineBarInit.setOption(option)
    },
    echartsLineBar2 () {
      this.echartsLineBar2Init = echarts.init(this.$refs.LineBar2, theme1)
      let seriesData = []
      this.orderIncomeChartData.legend.forEach((item, index) => {
        let seriesItem = {
          name: item,
          type: 'bar',
          data: this.orderIncomeChartData.series[item]
        }
        if (this.orderIncomeChartData.legend.length - 1 === index) {
          seriesItem.type = 'line'
          seriesItem.yAxisIndex = 1
        }
        seriesData.push(seriesItem)
      })
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: (params) => {
            let tmpStr = `${params[0].axisValueLabel}<br/>`
            let paramsLen = params.length
            params.forEach((item, index) => {
              tmpStr += `${item.marker}  ${item.seriesName} : ${item.data} ${index === paramsLen - 1 ? '%' : '元'}<br/>`
            })
            return tmpStr
          }
          //'{a0}: {c0}元<br />{a1}: {c1}元<br/>{a2}: {c2}%'
        },
        legend: {
          data: this.orderIncomeChartData.legend
        },
        xAxis: [
          {
            type: 'category',
            data: this.orderIncomeChartData.xAxis,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            //name: '(单位:元)',
            min: 0,
            //interval: 50,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '',
            min: 0,
            show: false,
            //interval: 5,
            axisLabel: {
              formatter: '{value}%'
            }
          }
        ],
        series: seriesData
        /* [
          {
            name: '优惠成本',
            type: 'bar',
            data: this.orderIncomeChartData.series['优惠成本']
          },
          {
            name: '订单收益',
            type: 'bar',
            data: this.orderIncomeChartData.series['投资比']
          },
          {
            name: '投资比',
            type: 'line',
            yAxisIndex: 1,
            data: this.orderIncomeChartData.series['订单收益']
          }
        ] */
      }
      //this.echartsLineBar2Init.hideLoading()
      this.echartsLineBar2Init.setOption(option)
    },
    echartsBars () {
      this.echartsBarsInit = echarts.init(this.$refs.Bars, theme1)
      let seriesData = []
      this.orderDiscountChartData.legend.forEach(item => {
        let seriesItem = {
          name: item,
          type: 'bar',
          stack: true,
          label: {
            normal: {
              show: true,
              position: 'insideRight',
              formatter: function (params) {
                return params.value < 40 ? '' : params.value
              }
            }
          },
          data: this.orderDiscountChartData.series[item]
        }
        seriesData.push(seriesItem)
      })
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {// 坐标轴指示器，坐标轴触发有效
            type: 'shadow'// 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: (params) => {
            let tmpStr = `${params[0].axisValueLabel}<br/>`
            params.forEach(item => {
              tmpStr += `${item.marker}  ${item.seriesName} : ${item.data} 元<br/>`
            })
            return tmpStr
          }
          //'{b1}<br/>{a0}: {c0} 元<br/>{a1}: {c1} 元<br/>{a2}: {c2} 元'
        },
        legend: {
          data: this.orderDiscountChartData.legend
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          //name: '（单位:元)',
          type: 'value',
          nameLocation: 'middle'
        },
        yAxis: {
          type: 'category',
          data: this.orderDiscountChartData.xAxis
        },
        series: seriesData
        /* [
          {
            name: '充值优惠',
            type: 'bar',
            stack: true,
            label: {
              normal: {
                show: true,
                position: 'insideRight'
              }
            },
            data: this.orderDiscountChartData.series['充值优惠']
          },
          {
            name: '油价优惠',
            type: 'bar',
            stack: true,
            label: {
              normal: {
                show: true,
                position: 'insideRight'
              }
            },
            data: this.orderDiscountChartData.series['油价优惠']
          },
          {
            name: '优惠卷优惠',
            type: 'bar',
            stack: true,
            label: {
              normal: {
                show: true,
                position: 'insideRight'
              }
            },
            data: this.orderDiscountChartData.series['优惠卷优惠']
          }
        ] */
      }
      this.echartsBarsInit.hideLoading()
      this.echartsBarsInit.setOption(option)
    },
    echartsPie () {
      this.echartsPieInit = echarts.init(this.$refs.Pie, theme1)
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: <br/>{c} 元 ({d}%)'
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          y: 'bottom',
          data: this.gasStationChartData.legend
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
                //position: 'center'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: this.gasStationChartData.data
          }
        ]
      }
      this.echartsPieInit.setOption(option)
    },
    echartsFillPie () {
      this.echartsFillPieInit = echarts.init(this.$refs.PieFill, theme1)
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 'left',
        //   data: ['新用户', '连续活跃1个月', '连续活跃2个月', '连续活跃3个月', '其他用户']
        // },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            center: ['50%', '50%'],
            startAngle: 110,
            data: this.memberFormChartData.data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.echartsFillPieInit.setOption(option)
    },
    onRadioChange (val) {
      if (val === '0') {
        this.echartsBars()
      } else {
        //this.echartsLineBar2()
        this.fetchOrderIncomeChart()
      }
    },
    nextTickQueue (fn) {
      this.$nextTick(() => {
        fn()
      })
    },
    fetchCount () {
      fetch(url.count).then(res => {
        if (res.status === 200) {
          this.countData = res.data
        }
      })
    },
    fetchBacklog () {
      fetch(url.backlog).then(res => {
        if (res.status === 200) {
          this.backlogData = res.data
        }
      })
    },
    fetchIncomeChart () {
      fetch(url.incomeChart, {
        dateType: this.LineType
      }).then(res => {
        if (res.status === 200) {
          this.incomeChartData = res.data
          this.nextTickQueue(this.echartsLine)
        }
      })
    },
    fetchGasStationChart () {
      fetch(url.gasStationChart).then(res => {
        if (res.status === 200) {
          this.gasStationChartData = res.data
          this.nextTickQueue(this.echartsPie)
        }
      })
    },
    fetchNewMemberChart () {
      fetch(url.newMemberChart, {dateType: this.LineBarType}).then(res => {
        if (res.status === 200) {
          this.newMemberChart = res.data
          this.nextTickQueue(this.echartsLineBar)
        }
      })
    },
    fetchMemberFormChart () {
      fetch(url.memberFormChart).then(res => {
        if (res.status === 200) {
          this.memberFormChartData = res.data
          this.nextTickQueue(this.echartsFillPie)
        }
      })
    },
    fetchOrderDiscountChart () {
      fetch(url.orderDiscountChart).then(res => {
        if (res.status === 200) {
          this.orderDiscountChartData = res.data
          this.nextTickQueue(this.echartsBars)
        }
      })
    },
    fetchOrderIncomeChart () {
      fetch(url.orderIncomeChart).then(res => {
        if (res.status === 200) {
          this.orderIncomeChartData = res.data
          this.nextTickQueue(this.echartsLineBar2)
        }
      })
    }
  },
  filters: {
    currency,
    formatInvitationCouponNum (val, val2) {
      if (val2 === 0) {
        return '关闭'
      } else if (val2 === 2) {
        return '优惠券过期'
      } else if (val >= 20) {
        return '正常'
      } else if (val === null) {
        return '不限'
      } else if (val < 20) {
        return '数量报警'
      } else {
        return '关闭'
      }
    }
  },
  watch: {
    LineType () {
      this.fetchIncomeChart()
    },
    LineBarType () {
      this.fetchNewMemberChart()
    }
  }
}
</script>

<style lang="scss" scoped>
.groupEchartBtn {
  float: right;
  cursor: pointer;
  & > * {
    margin-left: 40px;
  }
  color: #B2B2B2;
  font-size: 14px;
}
.groupEchartBtn-active {
  color: $theme_color;
}
.indexEchartbox {
  height: 100%;
  box-sizing: border-box;
  border: 16px solid #f5f5f5;
  border-bottom: 0;
  //background-color: #fff;
  //padding-top: 20px;
}
.indexEchart {
  background-color: #f5f5f5;
  color: $black_color;
  font-size: 14px;
  .is-circle {
    // position: absolute;
    // top: 8px;
    // right: 8px;
    border-radius: 50%;
    padding: 8px;
    border: 0;
  }
  .indexEchart_title {
    padding-left: 16px;
    height: 40px;
    font-size: 16px;
    color: #353535;
    line-height: 40px;
    border-bottom: 1px solid #E8E8E8;
  }
  // 待办事项
  .still {
    padding: 8px;
    color: $black_color;
    height: 286px;
    min-width: 238px;
    .still_title {
      padding: 8px 0 8px 8px;
    }
    .agenda-item {
      padding-left: 16px;
      cursor: pointer;
      min-height: 38px;
      line-height: 38px;
      transition: background 1s;
      .icon-need {
        color: $red_color;
        font-size: 16px;
        padding-right: 8px;
      }
      .icon-noneed {
        color: $green_color;
        font-size: 16px;
        padding-right: 8px;
      }
      .agenda-item__count {
        padding-left: 8px;
      }
    }
    .agenda-item:hover {
      background-color: $pink_color;
    }
    .agenda-item:hover {
      background-color: $pink_color;
      color: $red_color;
    }
  }
  // 油站收入
  .paycheck {
    .paycheck_title {
      padding: 16px 24px;
    }
  }
  .el-row:first-child {
    background-color: $bg_color;
    border: 1px solid #E8E8E8;
  }
  .el-row {
    margin-top: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-row:first-child {
    margin-top: 0;
  }
  .el-col.el-col-6 {
    padding: 0 !important;
  }
  .grid-content {
    cursor: pointer;
    padding: 24px 0 24px 16px;
    border-right: 1px solid #e8e8e8;
    //margin-bottom: 20px;
    font-size: 0;
    .commonicon {
      color: #fec6cd;
      display: block;
      font-size: 16px;
      vertical-align: bottom;
      padding: 24px 13px 0 16px;
    }
    .grid-right-content {
      position: relative;
      font-size: 16px;
      // .iconbox {
      //   float: left;
      // }
      // .textbox {
      //   float: left;
      // }
      .rangeUp {
        // margin-right: 6px;
        color: $green_color;
      }
      .rangedown {
        // margin-right: 6px;
        color: $red_color;
      }
      .textGray {
        height: 21px;
        color: $gray_color;
        font-size: 14px;
      }
      .grid-right-content__count {
        line-height: 1;
        font-size: 30px;
        padding: 12px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .no-border{
    border: 0;
  }
  .el-card {
    //background-color: #f5f5f5;
    .el-card__body {
      padding: 0;
      width: auto;
      overflow: hidden;
    }
  }
}
.el-container {
  overflow-y: hidden !important;
}
@media screen and (max-width: 1040px) {
  .still {
    .agenda-item__count {
      display: none;
    }
  }
}
</style>

<style lang="scss">
.indexEchartbox {
  .el-card__header {
    padding-left:16px;
    padding-top:16px;
    padding-bottom: 8px;
    border-bottom:0;
    color: #353535;
  }
  .el-card__body {
    position: relative;
    padding: 0;
  }
  .el-card.is-always-shadow{
    box-shadow: none;
    border: 1px solid #e8e8e8;
    border-radius: 0;
  }
  .icon-greenUp,  .icon-redDown{
    display: inline-block;
    vertical-align: baseline;
    font-size: 12px;
    transform: scale(0.8);
  }
}

</style>
